/** Currency symbols commonly present in SQL column labels. */
const CURRENCY_SYMBOLS = /[$€£¥₹₨₩₪₫₭₮₯₰₱₲₳₴₵₶₷₸₺₻₼₽₾₿]/g;

/** Percent (ASCII + fullwidth). */
const PERCENT_SYMBOLS = /[%％]/g;

/** Parentheses, brackets, braces (ASCII + common Unicode variants). */
const BRACKET_SYMBOLS = /[()[\]{}（）【】［］〔〕]/g;

/**
 * Strip currency, percent, and bracket characters before sending column_name to sort API.
 */
export function sanitizeSortColumnName(columnName) {
  if (columnName == null) return "";
  return String(columnName)
    .replace(CURRENCY_SYMBOLS, "")
    .replace(PERCENT_SYMBOLS, "")
    .replace(BRACKET_SYMBOLS, "")
    .replace(/\s+/g, " ")
    .trim();
}
